import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const handleChange = onChange => e => onChange(e.target.value);
const handleKeyPress = onKeyPress => e => onKeyPress(e.key);

const Input = ({
  autoComplete,
  error,
  handleRef,
  onChange,
  onKeyPress,
  placeholder,
  className,
  name,
  type,
  value,
}) => (
  <StyledInput
    autoComplete={autoComplete}
    className={`${className} ${error ? 'invalid' : ''}`}
    data-cy={`input-${name}`}
    onChange={handleChange(onChange)}
    onKeyPress={handleKeyPress(onKeyPress)}
    placeholder={placeholder}
    ref={handleRef}
    type={type}
    value={value}
  />
);

Input.propTypes = {
  autoComplete: PropTypes.string,
  handleRef: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
};

Input.defaultProps = {
  autoComplete: '',
  handleRef: () => {},
  error: '',
  onChange: () => {},
  type: '',
  value: '',
};

const StyledInput = styled.input`
  background-color: ${props => props.theme.lightestGray};
  border: 1px solid ${props => props.theme.border};
  border-radius: 3;
  box-shadow: inset ${props => props.theme.shadow};
  display: block;
  font-size: ${props => props.theme.formFontSize};
  font-weight: 300;
  height: ${props => props.theme.inputHeight};
  outline: ${props => props.theme.outline};
  transition: all 150ms;
  padding: ${props => props.theme.siblingSpacing}px;
  width: 100%;
  color: ${props => props.theme.text};

  &::placeholder {
    color: ${props => props.theme.placeholder};
  }
  &:-ms-input-placeholder {
    color: ${props => props.theme.placeholder};
  }
  &.invalid {
    border-color: ${props => props.theme.danger};
  }
`;

export default Input;
